import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';

export function useAdminThread(db, itemId, userEmail) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!itemId || !userEmail) return;
    setLoading(true);
    const offerDocId = `${itemId}_${userEmail}`;
    const offerRef = doc(db, "offers", offerDocId);

    const unsubscribe = onSnapshot(
      offerRef,
      (docSnap) => {
        if (docSnap.exists()) {
          setMessages(docSnap.data().messages || []);
        } else {
          setMessages([]);
        }
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [db, itemId, userEmail]);

  return { messages, loading, error };
}